import React from "react";
import Form from "react-bootstrap/Form";
import PropTypes from "prop-types";

const RolesSelect = ({onChange, options, value, className, id}) => {
    
return (
    <Form.Control id={id} as="select" multiple value={value ? [value] : []} onChange={onChange} className={className}>
  		{options?.map((val) => (
				<option key={val.id} value={val.id}>{val.name}</option>                      
		 	))
		 }
  	</Form.Control>
  );
};

RolesSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  id: PropTypes.string,
};

RolesSelect.defaultProps = {
  options: [],
  value: "",
  className: "",
  id: undefined,
};

export { RolesSelect };
